/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ConstantConfigurationModel {
        public constants: Wars.Domain.Model.ConstantValue[];
        private systemLevel: Wars.Domain.Model.SystemLevel;

        public constructor(
            private constantService: services.ConstantService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            public id: string,
            private growl: angular.growl.IGrowlService)
        {
            this.dropDownContext.includeSpecifiedOptionsOnly = [
                Wars.Domain.Model.Codes.Enums.VariableType.String,
                Wars.Domain.Model.Codes.Enums.VariableType.Integer,
                Wars.Domain.Model.Codes.Enums.VariableType.Decimal,
                Wars.Domain.Model.Codes.Enums.VariableType.Boolean];

            if (id) {
                constantService.getAllConstantsForProcessConfiguration(id).then(c => {
                    this.constants = c;
                });
            } else {
                systemLevelService.getSystemLevelConstants().then(systemLevel => {
                    this.systemLevel = systemLevel;
                    this.constants = systemLevel.myConstants;
                });
            }
        }

        public dropDownContext : models.EnumDropDownContext = new EnumDropDownContext();
        
        public addConstant() {
            var newConstant = this.constantService.createConstant();

            if (this.id) {
                newConstant.processConfiguration_id = this.id;
            } else {
                newConstant.systemLevel_id = this.systemLevel.id;
            }

            this.constants.push(newConstant);
        }

        public removeConstant(constant: Wars.Domain.Model.ConstantValue) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ConstantValue",
                constant.id,
                "Constant",
                () => {
                    this.constants.remove(constant);
                });
        }

        public cancel() {
            this.constantService.rejectChanges();
        }

        public save() {
            this.constantService.saveAllChanges();
        }
    }
}